import {
  defaultDataIdFromObject,
} from '@apollo/client';
import {
  StoreObject,
} from '@apollo/client/cache';
import { relayStylePagination } from '@apollo/client/utilities';
import { FieldFunctionOptions } from '@apollo/client/cache/inmemory/policies';

import { ProductPaginationType } from '@models';

const CATALOG_FILTERS_KEYS = [
  'orderBy', 'collectionSlug', 'sizes', 'conditions', 'colors', 'priceTo',
  'priceFrom', 'catalogSlug', 'brands', 'priceId', 'ukrainian', 'searchText',
];

export const dataIdFromObject = (object: Readonly<StoreObject>) => {
   
  switch (object.__typename) {
    case 'UserDeliverySettings':
      return object.deliveryService as string;
    case 'ReturnPolicySetting':
      return object.returnPolicy as string;
    case 'UserAccount':
      return `UserAccount:${object.type}`;
    case 'Basket':
      return 'Basket';
    case 'ReviewQuestionValue':
      return `ReviewQuestionValue:${object.id}:${object.text}`;
    case 'PlanType':
      return `PlanType:${object.planId}`;
    case 'SubscriptionInfo':
      return 'SubscriptionInfo';
    case 'Photo':
      return `Photo:${object.idStr}`;
    case 'Notification':
      return `Notification:${object.idStr}`;
    case 'Catalog':
      return `Catalog:${object.slug}`;
    default:
      return defaultDataIdFromObject(object);
  }
};

const productRelayStylePagination = relayStylePagination(CATALOG_FILTERS_KEYS);
export const typePolicies = {
  Query: {
    fields: {
      activeSales: relayStylePagination(),
      postsForGeneral: relayStylePagination(),
      postsLikedByViewer: relayStylePagination(),
      outfits: relayStylePagination(),
      topProducts: {
        keyArgs: [],
      },
      topProductsV2: {
        keyArgs: [],
         
        merge(existing = [], incoming: never[], options: FieldFunctionOptions) {
          if (options.args && options.args.paginationType === ProductPaginationType.Page) {
            if (incoming) {
              return incoming;
            }
            return existing;
          }

          // @ts-ignore
           
          return productRelayStylePagination.merge(existing, incoming, options);
        },
      },
      products: {
        keyArgs: [],
         
        merge(existing = [], incoming: never[], options: FieldFunctionOptions) {
          if (options.args && 'pageNum' in options.args) {
            if (incoming) {
              return incoming;
            }
            return existing;
          }

          // @ts-ignore
           
          return productRelayStylePagination.merge(existing, incoming, options);
        },
      },
      productReviews: relayStylePagination(['productId']),
      productsAvailabilityFeedbacks: {
        merge: false,
      },
    },
  },
  DynamicCollection: {
    fields: {
      products: relayStylePagination([
        'orderBy', 'sizes', 'condition', 'colors', 'priceTo',
        'priceFrom', 'catalogSlug', 'brands', 'priceId', 'ukrainian',
        'cities', 'characteristics', 'freeShipping', 'isOnSale',
      ]),
    },
  },
  User: {
    fields: {
      productsBySubscriptions: relayStylePagination(),
      viewerProducts: relayStylePagination(),
      paymentTransactions: relayStylePagination(),
      reviews: relayStylePagination(['filters', 'username']),
      favourites: relayStylePagination([
        'orderBy', 'sizes', 'condition', 'colors', 'priceTo',
        'priceFrom', 'catalogSlug', 'brands', 'priceId', 'ukrainian',
        'cities', 'characteristics', 'freeShipping', 'isOnSale',
      ]),
      threads: relayStylePagination(['filters']),
      notifications: relayStylePagination(),
      reviewRequests: relayStylePagination(),
      confirmedPotentialDealDialogs: relayStylePagination(),
      products: relayStylePagination(CATALOG_FILTERS_KEYS),
      posts: relayStylePagination(),
    },
  },
  ViewerType: {
    fields: {
      postsSaved: relayStylePagination(),
      postsLiked: relayStylePagination(),
    },
  },
  VirtualCatalog: {
    fields: {
      products: relayStylePagination(CATALOG_FILTERS_KEYS),
    },
  },
  Thread: {
    fields: {
      messages: relayStylePagination(),
    },
  },
  StaticFlags: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    merge(existing = [], incoming: any[]) {
       
      return { ...existing, ...incoming };
    },
  },
  Message: {
    fields: {
       
      isScheduleToSend: (value = false) => (value),
    },
  },
  Basket: {
    merge: false,
    fields: {
      groups: {
        merge: false,
      },
    },
  },

  PostType: {
    fields: {
      postsSimilar: relayStylePagination(),
    },
  },
};
